import { createAsyncThunk } from '@reduxjs/toolkit';

import { auth } from 'src/app/database';
import api from 'src/app/apiSingleton';

import { clearCriticalConfigurationState } from './criticalConfiguration.slice';

export const getCriticalPlans = createAsyncThunk(
  'critical-configuration/get-critical-plans',
  async (data, thunkApi) => {
    try {
      const { accountId, proposalId, read_token } = data;

      if (!read_token) {
        const token = await auth.currentUser.getIdToken();
        api.apiClient.setToken(token);
      }

      const response = await api.criticalConfiguration.getCriticalPlans(
        accountId,
        proposalId,
        read_token,
      );

      return response;
    } catch (err) {
      console.warn(err);
    }
  },
);

export const getCriticalQuotePlans = createAsyncThunk(
  'critical-configuration/get-critical-quote-plans',
  async (data, thunkApi) => {
    try {
      const { accountId, proposalId, read_token } = data;

      if (!read_token) {
        const token = await auth.currentUser.getIdToken();
        api.apiClient.setToken(token);
      }

      const response = await api.criticalConfiguration.getCriticalQuotePlans(
        accountId,
        proposalId,
        read_token,
      );

      return response;
    } catch (err) {
      console.warn(err);
    }
  },
);

// CLEAR STATE

export const clearCriticalState = createAsyncThunk('critical/clear-state', (data, thunkApi) => {
  thunkApi.dispatch(clearCriticalConfigurationState());
});
